import SwapVertIDownActive from '@assets/icons/swap-vert-down-active.svg'
import { Icon } from './Icon'

export const SwapVertIDownActiveIcon = Icon(SwapVertIDownActive)
